import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';

import CurrentUserActions from '../actions/CurrentUserActions';
import FlatPageActions from '../actions/FlatPageActions';

const FlatPageSource = {
    getPages() {
        return {
            remote(state) {
                return new Promise((resolve, reject) => {
                    new SingleObjectResource(DJ_CONST.API.flatpageList).fetch().then((data) => {
                        resolve({data});
                    }, (error) => {
                        if (error.statusCode !== 403) {
                            // Trigger a global error
                            CurrentUserActions.pageFault(error);
                            reject();
                        } else {
                            reject();
                        }
                    }).catch((error) => {
                        // Trigger a global error
                        CurrentUserActions.pageFault(error);
                        reject();
                    });
                });
            },

            local(state) {
                // So we don't do the call again when rendering clientside
                // Note: We may want to recheck from backend after certain time interval
                return state.cacheTimestamp ? state : null;
            },

            success: FlatPageActions.receivedPages,
            error: CurrentUserActions.pageFault
        };
    }
};


class FlatPageStore {
    constructor() {
        this.pages = [];

        this.exportAsync(FlatPageSource);
        this.bindActions(FlatPageActions);
        this.exportPublicMethods({
            hasLoaded: this.hasLoaded
        });
    }

    hasLoaded() {
        return !!this.getState().cacheTimestamp;
    }

    onReceivedPages(pages) {
        this.pages = pages.data;
    }
}

export default createStore(FlatPageStore, 'FlatPageStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/FlatPageStore.js
 **/